<template>
  <div class="tw-flex tw-flex-col sm:tw-items-center tw-justify-center tw-h-screen tw-bg-gray-100">
    <div
      class="tw-w-full tw-px-3 sm:tw-max-w-md tw-rounded-lg tw-bg-gray-200 tw-text-gray-800 tw-text-sm tw-border tw-border-gray-500 tw-py-3 tw-text-center tw-flex tw-mb-3"
      v-if="!!message"
    >
      <alert-icon class="tw-h-6 tw-w-6 tw-text-gray-800 tw-mr-2" />
      <span class="tw-my-auto">{{ message }}</span>
    </div>
    <sign-in-card class="tw-w-full sm:tw-max-w-md" @success="redirect" :is-loading="isLoading" />
  </div>
</template>

<script>
import SignInCard from "@/components/SignInCard";
import { mapGetters, mapActions } from "vuex";
import redirect from "@/mixins/redirect";
import { AlertIcon } from "@/assets/svgs";

export default {
  mixins: [redirect],
  components: {
    SignInCard,
    AlertIcon,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    message() {
      return this.$route.query.m;
    },
    ...mapGetters("organization", ["organization", "organizations", "isOrganizationPredictile", "isOrganizationBusiness", "isOrganizationUser", "hasMultipleOrganizations"]),
    ...mapGetters("cognito", ["id"]),
  },
  methods: {
    ...mapActions("organization", { orgInit: "init" }),
    ...mapActions("role", { roleInit: "init" }),
    ...mapActions("memberInvites", { memberInviteInit: "init" }),
    async redirect() {
      try {
        this.isLoading = true;
        sessionStorage.removeItem("pinMode");
        sessionStorage.removeItem("hasStartedPinMode");
        this.$store.dispatch("cognito/initPinMode");
        await this.acceptExistingBusiessUserInvites();
        await Promise.all([this.orgInit(), this.roleInit(), this.memberInviteInit(), this.checkCobrand()]);

        if (this.$route.query.returnUrl) {
          await this.$router.push(this.$route.query.returnUrl);
        } else {
          await this.redirectToHome();
        }
      } finally {
        this.isLoading = false;
      }
    },
    async acceptExistingBusiessUserInvites() {
      await this.$axios.post("/user-invites/accept-existing");
    },
    async checkCobrand() {
      const response = await this.$axios.get(`/users/${this.id}/cobrand`);
      this.$store.commit("organization/setCobrand", response.data.cobrandId);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .card-width {
    width: 450px;
  }
}
@media screen and (max-width: 768px) {
  .col {
    padding: 0px;
    min-height: 100vh;
  }
}
</style>
